/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import GradientButton from '../../MUICustomButton/GradientButton'
import CustomDataTable from '../../CustomDataTable/CustomDataTable'
import type { TableColumn } from 'react-data-table-component'
import type { Client, ClientApiResponse, ClientStatusObj, RootState } from '../../types/types'
import { Link } from 'react-router-dom'
import { IconButton, Menu, MenuItem } from '@mui/material';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { UPDATE_CLIENT_ACTIVATE_SUBTITLE_1, UPDATE_CLIENT_DEACTIVATE_SUBTITLE_1, UPDATE_CLIENT_DEACTIVATE_SUBTITLE_2 } from 'src/constants/constant'
import OutlineButton from '../../MUICustomButton/OutlineButton'
import { useSelector } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { changeStatusClientData, getAllEmailAPIClient } from 'src/services/emailAPIClientServices'
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MoreVerticalSolidRounded} from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';
import { useNavigate } from 'react-router-dom';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;



function EmailAPIClientList(): JSX.Element {

  const [loading, setLoading] = useState<boolean>(false)
  const [clientListData, setClientListData] = useState<Client[]>([])
  const [clientSearchData, setClientSearchData] = useState<Client[]>([])
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const [selectedClientData, setSelectedClientData] = useState<Client>();
  const [showDeactivateClientModal, setShowDeactivateclientModal] = useState<boolean>(false)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)

  const { user } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate()

  useEffect(() => {
    getClientData()
  }, [])

  const getClientData = (): void => {
    setLoading(true)
    getAllEmailAPIClient()
      .then(
        (res: ClientApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              const clientArr: any = [];
              res.data.data.map((data: any) => {
                  clientArr.push(data)
                // }
              })
              setClientListData(clientArr)
              setClientSearchData(clientArr)
            }

          }
        }
      )
      .catch(
        error => console.log("Error: ", error)
      )
      .finally(() => {
        setLoading(false)
      })
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleActionClose = (event: React.MouseEvent<HTMLElement>, rowData: Client, action: string | null = null): void => {
    setSelectedClientData(rowData)
    if (action === "deactivate" || action === "activate") {
      setShowDeactivateclientModal(true)
    }
    setAnchorActionEl({ ...anchorActionEl, [rowData.id]: null });
  }

  const handleAddClientClick = (): void => {
    navigate('/email-api/manage-clients/add-client')
  }

  const handleDeactivateClientClose = (): void => {
    setShowDeactivateclientModal(false)
  }

  const handleDeactivateClientConfirm = async (): Promise<void> => {
    console.log("confirm")
    setIsModalSaveLoading(true)
    const data: ClientStatusObj = {
      "modifiedBy": user?.id,
      "isActive": selectedClientData?.isActive === true ? false : true,
      "clientLst": [
        {
          "id": selectedClientData?.id
        }
      ]
    }
    try {
      const res = await changeStatusClientData(data);

      if (res.status === 200) {
        if (res.data.result === 1) {
          NotificationManager.success(
            ((selectedClientData?.isActive) === true)
              ? "Client deactivated successfully"
              : "Client activated successfully"
          );

          getClientData();
        }
      }
    } catch (error) {
      console.error("Error activating/deactivating client:", error);
      NotificationManager.error("An error occurred. Please try again.");
    } finally {
      setShowDeactivateclientModal(false);
      setIsModalSaveLoading(false);
    }
  }



  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    let clientDataArr = [...clientListData]
    if (value !== "") {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
      clientDataArr = clientDataArr && clientDataArr.filter((client: Client) => {
        return client.clientName.toLowerCase().search(value.toLowerCase()) >= 0
      })
    }

    setClientSearchData(clientDataArr)
  }

  const columns: TableColumn<any>[] = [
    {
      name: 'Client Name',
      selector: (row: any) => row.clientName,
      width: '25%',
      sortable: true
    },
    {
      name: 'Client Contact',
      sortable: true,
      selector: (row: any) => row.clientContact,
      width: '20%',
      cell: (row: any) => <span>{row.clientContact}</span>
    },
    {
      name: 'Email',
      sortable: true,
      width: '25%',
      selector: (row: any) => row.email,
      cell: (row: any) => <span>{row.email}</span>
    },
    {
      name: 'Status',
      sortable: false,
      width: "18%",
      // selector: row => row.year,
      cell: (row: any) => {
        return row.isActive ? <div className="badge truncate" style={{
          background: '#CCFFEA',
          padding: '10px 15px',
          color: '#06A864',
          border: '0px'
        }}>Active</div> : <div className="badge truncate" style={{
          background: '#FFF5F6',
          padding: '10px 15px',
          color: '#F13139',
          border: '0px'
        }}>Inactive</div>
      }
    },
    {
      name: 'Actions',
      sortable: false,
      id: 'action',
      width: "7%",
      style: {
        display: 'flex',
        justifyContent: 'flex-start'
      },
      // selector: row => row.year,
      cell: (row: any) => {
        return (
          <div className='flex items-center'>
            <div className="icon-hover-container">
              <Link to={{ pathname: `/email-api/manage-clients/edit/${row.id}` }} state={{ clientData: row }} style={{ width: '20px' }} >
                <HugeiconsIcon
                  icon={PencilEdit02Icon}
                  size={20}
                  color="#3A3A3A"
                  strokeWidth={0.2}
                />
              </Link>
            </div>
            <div className='flex'>
              <IconButton
                aria-label="more"
                id="long-button"
                // aria-controls={open ? 'long-menu' : undefined}
                // aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={(e) => handleActionClick(e, row.id)}
              >
                <HugeiconsIcon
                                              icon={MoreVerticalSolidRounded}
                                              size={20}
                                              color="#3A3A3A"
                                              strokeWidth={0.2}
                                            />
              </IconButton>
              <Menu
                id={row.id.toString()}
                className='table-action-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorActionEl[row.id]}
                open={Boolean(anchorActionEl[row.id])}
                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
               slotProps={{ paper: {
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '15ch',
                  },
                }}}
              >
                <MenuItem onClick={(e) => handleActionClose(e, row, row.isActive === true ? "deactivate" : "activate")}>
                  <span style={{ paddingLeft: '15px' }} className='text-muted font-normal'>{row.isActive === true ? "Deactivate" : "Activate"}</span>
                </MenuItem>
              </Menu>
            </div>

          </div>
        )
      }
    },
  ]

  return (
    <React.Fragment>
      <h2 className="text-2xl font-semibold text-title">Manage Clients</h2>
      <div className="flex my-5 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="form-control">
            <input type="text" placeholder="Search Client" className="input input-bordered w-auto search-input-white focus:ring-0 focus:outline-none focus:border-primary font-normal text-14 text-muted" onChange={handleSearch} />
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">

          <GradientButton color='red' onClick={handleAddClientClick}>
            <span style={{
              width: "20px",
              height: "20px",
              background: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50px",
              marginRight: "5px"
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
              </svg>
            </span>
            Add New Client
          </GradientButton>
        </div>
      </div>
      <div className='data-table-container mb-10'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          data={clientSearchData.length > 0 ? clientSearchData : []}
          pagination
          selectableRows
          progressPending={loading}
        />
      </div>

      <BootstrapDialog
        onClose={handleDeactivateClientClose}
        aria-labelledby="customized-dialog-title"
        open={showDeactivateClientModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          {selectedClientData && selectedClientData.isActive === true ? "Deactivate Client" : "Activate Client"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleDeactivateClientClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
           <HugeiconsIcon
                                     icon={MultiplicationSignStrokeStandard}
                                     size={24}
                                     color="currentcolor"
                                     strokeWidth={0.5}
                                   /> 
        </IconButton>
        <DialogContent>
          {
            selectedClientData !== undefined && selectedClientData.isActive === true ?
              <p className='text-14 text-muted'>{UPDATE_CLIENT_DEACTIVATE_SUBTITLE_1} <span className='font-semibold'>{`${selectedClientData !== undefined ? selectedClientData.clientName : ''} `}</span> {UPDATE_CLIENT_DEACTIVATE_SUBTITLE_2}</p>
              :
              <p className='text-14 text-muted'>{UPDATE_CLIENT_ACTIVATE_SUBTITLE_1} <span className='font-semibold'>{`${selectedClientData !== undefined ? selectedClientData.clientName : ''}`}</span> {UPDATE_CLIENT_DEACTIVATE_SUBTITLE_2}</p>
          }

        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>
          <OutlineButton color='gray' onClick={handleDeactivateClientClose} width='130px'>Cancel</OutlineButton>
          {/* <Button btntype="submit" label={!isModalSaveLoading ? "Delete" : <span className="loading loading-spinner loading-xs text-white"></span>} isGradient={true} color={"primary"} size={"small"} onClick={handleDeleteUserConfirm} disabled={isModalSaveLoading}></Button> */}
          <GradientButton color='red' onClick={() => {
            void handleDeactivateClientConfirm();
          }} width='130px'>{
              isModalSaveLoading ? (
                <span className="loading loading-spinner loading-xs text-white"></span>
              ) : ((selectedClientData?.isActive) === true) ? "Deactivate" : "Activate"
            }</GradientButton>
        </DialogActions>
      </BootstrapDialog>


    </React.Fragment>
  )
}

export default EmailAPIClientList